import { createContext, useContext, useState, useEffect } from 'react'
import CryptoJS from 'crypto-js';
import axios from '../api/axios';

const VALIATE_USER_URL = "/validateUser";
const AESEncryptKey = "key2025";

export const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {

  const [loggedIn, setLoggedIn] = useState(JSON.parse(localStorage.getItem('loggedIn')))
  const [userId, setUserId] = useState(null)
  const [userName, setUserName] = useState(localStorage.getItem('userName'))
  const [userRole, setUserRole] = useState(localStorage.getItem('role') && JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('role'), AESEncryptKey).toString(CryptoJS.enc.Utf8)))
  const [showUserAuth, setShowUserAuth] = useState(false);

  const login = (token, id, role, name, orgId) => {
    setLoggedIn(true)
    setUserRole(role)
    setUserId(id)
    setUserName(name)
    setShowUserAuth(false)
    localStorage.setItem("token", token)
    localStorage.setItem("role", CryptoJS.AES.encrypt(JSON.stringify(role), AESEncryptKey).toString())
    localStorage.setItem("userName", name)
    localStorage.setItem("loggedIn", true)
    localStorage.setItem("orgId", orgId)
    localStorage.setItem("id", id)
  }

  const logout = () => {
    setLoggedIn(false)
    setUserRole(null)
    localStorage.removeItem('role')
    localStorage.removeItem('userName')
    localStorage.removeItem("loggedIn")
    localStorage.removeItem("token")
    localStorage.removeItem("orgId")
    localStorage.removeItem("id")
  }



  useEffect(() => {
    const userToken = localStorage.getItem('token')

    // console.log("validate token: " + userRole + ": " + userToken)

    if (userToken) {

      const config = {
        'token': userToken,
      };

      axios.post(VALIATE_USER_URL, config).then((response) => {
        console.log(response)
        if (response?.data?.body?.code === 0) { // token is valid
          login(userToken,
            response.data.body.message.user.id,
            response.data.body.message.user.role,
            response.data.body.message.user.first + " " + response.data.body.message.user.last,
            response.data.body.message.user.orgId
          )
        } else if (response?.data?.code === 200) { // token is invalid
          logout()
        } else if (response?.data?.code === 106) { // token has expired
          logout()
        } else if (response?.status === 400) { // any other error
          logout()
        }
      }).catch((err) => {
        console.log(err)
      })
    }

  }, [])

  //Logout second browser
  useEffect(() => {
    const syncLogout = (event) => {
      if (event.key === "loggedIn" && event.newValue === null) {
        // loggedIn removed -> logout from all tabs
        logout();
      }
    };

    window.addEventListener("storage", syncLogout);

    return () => {
      window.removeEventListener("storage", syncLogout);
    };
  }, []);

  return (
    <AuthContext.Provider value={{ loggedIn, login, logout, userId, userRole, userName, showUserAuth, setShowUserAuth }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => {
  return useContext(AuthContext)
}